/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_DeleteInputs */

const en_carrier_notices_delete = /** @type {(inputs: Carrier_Notices_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete notice`)
};

const es_carrier_notices_delete = /** @type {(inputs: Carrier_Notices_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar aviso`)
};

/**
* | output |
* | --- |
* | "Delete notice" |
*
* @param {Carrier_Notices_DeleteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_delete = /** @type {((inputs?: Carrier_Notices_DeleteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_DeleteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_delete(inputs)
	return es_carrier_notices_delete(inputs)
});